import { call } from "redux-saga/effects";
import { API_URL, sagaFunction } from "../_config";
import { CallApi } from "./api/callApi";

export function* getCmsContent(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.CMS.GET_CMS, action.payload, true);
}

export function* getBlocks(action: any): any {
  //  const yieldPuts = [{ type: ACTIONS.CMS.GET_BLOCKS }];
  yield call(sagaFunction, action, CallApi.GET, API_URL.CMS.GET_BLOCKS, action.payload, true);
}

export function* getLivePerformance(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.CMS.GET_LIVE_PERFORMANCE, action.payload, true);
}
